import request from '@/utils/request'



export function registerApi(data) {
	return request({
		url: '/api/common/v1/user/register',
		method: 'post',
		data,
		headers: {
			isToken: false
		}
	})
}

export function registerUserApi(data) {
	return request({
		url: '/register/user',
		method: 'post',
		data
	})
}

export function registerUkeyApi(data) {
	return request({
		url: '/register/key',
		method: 'post',
		data
	})
}

export function checkPhoneAccount(data) {
	return request({
		url: '/api/common/v1/user/checkPhoneAccount',
		method: 'post',
		data
	})
}

export function formRandomUserName(data) {
	return request({
		url: '/api/common/v1/user/formRandomUserName',
		method: 'post',
		data
	})
}

export function checkAccountUnique(data) {
	return request({
		url: '/api/common/v1/user/checkAccountUnique',
		method: 'post',
		data
	})
}

export function phoneCompanyInfoList(data) {
	return request({
		url: '/api/common/v1/user/phoneCompanyInfoList',
		method: 'post',
		data
	})
}


